import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { FormGroup, FormControl, FormBuilder, NgForm } from "@angular/forms";
import * as XLSX from "xlsx";

import { ActivatedRoute, Router, ParamMap } from "@angular/router";
import { ApiLoginService } from "@app/api/api-login.service";
import { ApiContentService } from "@app/api/api-content.service";
import { ApiPartnerService } from "@app/api/api-partner.service";
import { LoadJsService } from "../../load-js/load-js.service";

@Component({
  selector: "app-adminnextsys-listorderstb-detail",
  templateUrl: "./adminnextsys-listorderstb-detail.component.html",
  styleUrls: ["./adminnextsys.component.css"],
})
export class AdminNextsysListOrderStbDetailComponent implements OnInit {
  @ViewChild("fileUploader", { static: false })
  fileUploader: ElementRef;
  @ViewChild("fileReupload", { static: false })
  fileReupload: ElementRef;
  @ViewChild("target", { static: false })
  target: ElementRef;

  ViewDetail: any = [];
  ViewListstb: any = [];
  ViewListstbdraft: any = [];
  check1: any = [];
  check2: any = [];
  sts1: any = [];
  sts2: any = [];
  actionHistory: any = [];
  listservices: any = [];
  liststb: any = [];
  logactive: any = [];
  alert_act: any = [];
  Billing: any = [];
  itemdihapus: any = {};
  itemactive: any = {};
  itemproduct: any = {};
  isLoading: boolean = false;

  // paging:any = [];
  // msearch : string;
  // //paging_link : any = [];
  // page_self = [];
  // page_next = [];
  // page_prev = [];
  // meta = [];
  // last_index : number;
  // first_index : number;
  // total_count : number;
  // querySearch = false;
  // searching = false;
  // dataempty = true;
  // currentParams = {};
  // queryParams = '';
  // searchQueryParams = '';
  // href='';

  formStb = this.fb.group({
    id: [""],
  });
  formOrderUpload = this.fb.group({
    value_upload: [""],
    id: [""],
  });
  formOrderReupload = this.fb.group({
    value_upload: [""],
    id: [""],
  });
  formSetpaid = this.fb.group({
    id: [""],
    statuspaid: [""],
  });
  formProduct = this.fb.group({
    id: [""],
    productname: [""],
    billingtype: [""],
    producttype: [""],
    startdate: [""],
    enddate: [""],
    price: [""],
    age: [""],
    productsource: [""],
    provisioningcode: [""],
  });

  alert_success = false;
  alert_success2 = false;
  alert_success3 = false;
  alert_failed = false;
  alert_failed2 = false;
  alert_failed3 = false;
  alert_failedx = false;

  loading = false;
  loadingrow: any = [];

  response: any = [];
  response_stb_valid: any = [];
  response_stb_invalid: any = [];

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    public LoadJsOrder: LoadJsService,
    private router: Router,
    public partnerService: ApiPartnerService
  ) {}

  ngOnInit() {
    this.loadStart();
  }

  loadStart() {
    this.LoadJsOrder.loadScriptProductStb();
    let id = this.route.snapshot.paramMap.get("id");
    //alert(id);

    this.loadDetail(id);
    this.loadSTBdraft(id);
    // this.loadSTB(id); //on if pagination on
  }

  isNewupload(item: any) {
    // console.log(item);

    return item == 0 || item == null;
  }
  isdraft(item: any) {
    // console.log(item);

    return item.ordersts == 0 || item.ordersts == null;
  }
  islistdraft(item: any) {
    if (item.length != 0) {
      // console.log("masuk");
      // console.log(item);
      return true;
    } else {
      // console.log("gagal");
      return false;
    }
  }

  isApproval(item, x) {
    if (item == undefined) {
      return false;
    }

    if (item.approvalsts == undefined) {
      return false;
    } else if (item.approvalsts == x) {
      return true;
    } else {
      return false;
    }
  }

  isvalid(item: any) {
    // console.log(item);
    if (item == undefined) {
      return false;
    }
    if (item.approvalsts == undefined) {
      return false;
    }
    return item.approvalsts == 1 && item.atvnowsts == null;
  }
  isnotvalid(item: any) {
    if (item == undefined) {
      return false;
    }
    if (item.approvalsts == undefined) {
      return false;
    }
    return item.approvalsts != 1 && item.atvnowsts == null;
  }
  isactive(item: any) {
    // this.loading = false
    if (item == undefined) {
      return false;
    }
    if (item.approvalsts == undefined) {
      return false;
    }
    // console.log(item)
    return item.approvalsts == 1 && item.atvnowsts == 1;

    // if (item.logactivatestb == null) {
    //   return
    // }
    // return (item.statusid == 1)
  }

  loadDetail(id: any) {
    this.isLoading = true;
    return this.partnerService
      .GetListnextsysorderDetail(id)
      .subscribe((output: any) => {
        // console.log(output);
        this.isLoading = false;
        this.ViewDetail = output.data;
        this.listservices = output.data.services;
        this.liststb = output.data.stb;
        //  this.logactive = this.liststb[0].logactivatestb;

        //  console.log(this.liststb.length)
        //  this.isNewupload(this.liststb.length);
      });
  }

  loadSTBdraft(id: any) {
    return this.partnerService
      .GetViewliststbdraft(id)
      .subscribe((output: any) => {
        this.ViewListstbdraft = output.data;
        this.check1 = this.ViewListstbdraft.check1;
        this.check2 = this.ViewListstbdraft.check2;
        this.sts1 = output.sts1;
        this.sts2 = output.sts2;
      });
  }

  loadSTB(id: any) {
    return this.partnerService.GetViewliststb(id).subscribe((output: any) => {
      this.ViewListstb = output.data;

      // // start pagination
      // this.paging = output.pagex;
      // this.page_self = output.pagex.self;
      // this.page_next = output.pagex.next;
      // this.page_prev = output.pagex.prev;
      // this.meta = output.meta;
      // this.total_count = this.meta['totalCount'];
      // let self = this.page_self['page'];
      // if ( self * this.meta['perPage'] < this.meta['totalCount']){
      //   this.last_index = (self * this.meta['perPage']);
      // }else{
      //   this.last_index = this.meta['totalCount'];
      // }

      // this.first_index = ((self-1)*this.meta['perPage'])+1;
      // //end pagination
    });
  }

  onCheck(item: any) {
    // console.log(item)
    if (item == undefined) {
      return false;
    }
    if (item.status == undefined) {
      return false;
    }
    return item.status;
  }
  onActionClick(act: any, item: any) {
    this.alert_act = act;
    // console.log(act, item);
    if (act == "hapus") {
      this.itemdihapus = item;
    }
    if (act == "activate") {
      this.itemactive = item;
    }
    if (act == "change") {
      this.itemproduct = item;
      // this.onUpdate(item)
      console.log(item);
    }
  }

  onUpdate(item: any) {
    // console.log(item)
    return this.partnerService
      .GetProductsale(item.productid)
      .subscribe((output: any) => {
        // this.formOrder = output.data;
        this.formProduct.setValue(output.data);
        console.log(output.data);
      });
  }

  idReupload(id: any) {
    this.formOrderReupload.get("id").setValue(id);
  }

  processFile(event: any) {
    // console.log('masuk')
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>event.target;

    if (target.files.length !== 1) throw new Error("Cannot use multiple files");
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: "binary" });
      /* first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      /* save data */
      this.formOrderUpload
        .get("value_upload")
        .setValue(XLSX.utils.sheet_to_json(ws, { header: 0 }));
      this.formOrderReupload
        .get("value_upload")
        .setValue(XLSX.utils.sheet_to_json(ws, { header: 0 }));
      // console.log(this.formValidasiOrder.value)
    };
    reader.readAsBinaryString(target.files[0]);
  }
  submitSaveUpload(id: any, el: HTMLElement) {
    // this.alert_failed = false
    // this.alert_success = false
    // console.log(this.formOrder.value)
    this.formOrderUpload.get("id").setValue(id);

    this.partnerService
      .PostUploadnew(id, this.formOrderUpload.value)
      .subscribe((output: any) => {
        if (output.status) {
          this.ngOnInit();
          this.LoadJsOrder.loadScriptProductStb();
          this.alert_success = true;
          setTimeout(() => {
            el.scrollIntoView({ behavior: "smooth" });
          }, 500);
          setTimeout(() => {
            this.alert_success = false;
          }, 6000);

          // setTimeout(()=>{
          //   this.redirectSetlayanan("customers/services/"+output.data.customer.id);
          // }, 3000);
        } else {
          this.LoadJsOrder.loadScriptProductStb();
          this.alert_failed = true;
          setTimeout(() => {
            this.alert_failed = false;
          }, 6000);

          setTimeout(() => {
            el.scrollIntoView({ behavior: "smooth" });
          }, 500);
        }
        this.formOrderUpload.reset();
        this.fileUploader.nativeElement.value = null;
      });
  }

  submitSaveUploaddraft(id: any, el: HTMLElement) {
    // this.alert_failed = false
    // this.alert_success = false
    // console.log(this.formOrder.value)
    this.formOrderUpload.get("id").setValue(id);

    this.partnerService
      .PostNextsysUploaddraft(id, this.formOrderUpload.value)
      .subscribe((output: any) => {
        if (output.status) {
          this.ngOnInit();
          this.LoadJsOrder.loadScriptProductStb();
          this.alert_success2 = true;
          setTimeout(() => {
            el.scrollIntoView({ behavior: "smooth" });
          }, 500);
          setTimeout(() => {
            this.alert_success2 = false;
          }, 6000);

          // setTimeout(()=>{
          //   this.redirectSetlayanan("customers/services/"+output.data.customer.id);
          // }, 3000);
        } else {
          this.LoadJsOrder.loadScriptProductStb();
          this.alert_failed2 = true;

          setTimeout(() => {
            el.scrollIntoView({ behavior: "smooth" });
          }, 500);
          setTimeout(() => {
            this.alert_failed2 = false;
          }, 6000);
        }
        this.formOrderUpload.reset();
        this.fileUploader.nativeElement.value = null;
      });
  }

  submitSaveUploaddraftpaired(id: any, el: HTMLElement) {
    // this.alert_failed = false
    // this.alert_success = false
    // console.log(this.formOrder.value)
    this.formOrderUpload.get("id").setValue(id);

    this.partnerService
      .PostUploaddraftpaired(id, this.formOrderUpload.value)
      .subscribe((output: any) => {
        if (output.status) {
          this.ngOnInit();
          this.LoadJsOrder.loadScriptProductStb();
          this.alert_success2 = true;
          setTimeout(() => {
            el.scrollIntoView({ behavior: "smooth" });
          }, 500);
          setTimeout(() => {
            this.alert_success2 = false;
          }, 6000);

          // setTimeout(()=>{
          //   this.redirectSetlayanan("customers/services/"+output.data.customer.id);
          // }, 3000);
        } else {
          this.LoadJsOrder.loadScriptProductStb();
          this.alert_failed2 = true;

          setTimeout(() => {
            el.scrollIntoView({ behavior: "smooth" });
          }, 500);
          setTimeout(() => {
            this.alert_failed2 = false;
          }, 6000);
        }
        this.formOrderUpload.reset();
        this.fileUploader.nativeElement.value = null;
      });
  }

  submitSaveReupload(id: any, el: HTMLElement) {
    // this.alert_failed = false
    // this.alert_success = false
    // console.log(this.formOrder.value)
    this.formOrderReupload.get("id").setValue(id);

    this.partnerService
      .PostReuploadnew(id, this.formOrderReupload.value)
      .subscribe((output: any) => {
        if (output.status) {
          this.ngOnInit();
          this.LoadJsOrder.loadScriptProductStb();
          this.alert_success2 = true;

          setTimeout(() => {
            el.scrollIntoView({ behavior: "smooth" });
          }, 500);
          setTimeout(() => {
            this.alert_success2 = false;
          }, 6000);

          // setTimeout(()=>{
          //   this.redirectSetlayanan("customers/services/"+output.data.customer.id);
          // }, 3000);
        } else {
          this.LoadJsOrder.loadScriptProductStb();
          this.alert_failed2 = true;
          setTimeout(() => {
            this.alert_failed2 = false;
          }, 6000);

          setTimeout(() => {
            el.scrollIntoView({ behavior: "smooth" });
          }, 500);
        }
        this.formOrderReupload.reset();
        this.fileReupload.nativeElement.value = null;
      });
  }

  submitSetpaid(id: any, el: HTMLElement) {
    // this.formSetpaid.get('id').setValue(id)
    // this.formSetpaid.get('statuspaid').setValue(1)
    // console.log(this.formSetpaid.value)

    // this.partnerService.PostStatuspaid(this.formSetpaid.value)
    const data = { statuspaid: 1 }; //paid
    this.partnerService.PostStatuspaid(id, data).subscribe((output: any) => {
      if (output.status) {
        this.ngOnInit();
        this.LoadJsOrder.loadScriptProductStb();
        this.alert_success = true;

        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 500);
        setTimeout(() => {
          this.alert_success = false;
        }, 6000);
      } else {
        this.LoadJsOrder.loadScriptProductStb();
        this.alert_failed = true;
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 500);
        setTimeout(() => {
          this.alert_failed = false;
        }, 6000);
      }
    });
  }

  submitdraft(id: any, el: HTMLElement) {
    const countstball = this.ViewListstbdraft.length + this.liststb.length;

    // if (this.ViewListstbdraft.length <= this.ViewDetail.quota)
    if (countstball <= this.ViewDetail.quota) {
      this.partnerService
        .PostNextsysSubmitdraft(id)
        .subscribe((output: any) => {
          if (output.status) {
            this.ngOnInit();
            this.LoadJsOrder.loadScriptProductStb();
            this.alert_success3 = true;
            setTimeout(() => {
              el.scrollIntoView({ behavior: "smooth" });
            }, 500);
            setTimeout(() => {
              this.alert_success3 = false;
            }, 6000);
          } else {
            this.LoadJsOrder.loadScriptProductStb();
            this.alert_failed = true;
            setTimeout(() => {
              el.scrollIntoView({ behavior: "smooth" });
            }, 500);
            setTimeout(() => {
              this.alert_failed = false;
            }, 6000);
          }
        });
    } else {
      this.LoadJsOrder.loadScriptProductStb();
      this.alert_failedx = true;
      setTimeout(() => {
        this.alert_failedx = false;
      }, 6000);
    }
  }

  submithapus(item: any, el: HTMLElement) {
    const data = { stbsts: 3 }; //remove
    this.partnerService
      .PostRemovestb(item.id, data)
      .subscribe((output: any) => {
        if (output.status) {
          this.ngOnInit();
          this.LoadJsOrder.loadScriptProductStb();
          this.alert_success2 = true;
          setTimeout(() => {
            el.scrollIntoView({ behavior: "smooth" });
          }, 500);
          setTimeout(() => {
            this.alert_success2 = false;
          }, 6000);
        } else {
          this.LoadJsOrder.loadScriptProductStb();
          this.alert_failed2 = true;
          setTimeout(() => {
            this.alert_failed2 = false;
          }, 6000);
        }
      });
  }

  submithapusdraft(item: any, el: HTMLElement) {
    const data = { statusid: 3 }; //remove
    this.partnerService
      .PostRemovestbdraft(item.id, data)
      .subscribe((output: any) => {
        if (output.status) {
          this.ngOnInit();
          this.LoadJsOrder.loadScriptProductStb();
          this.alert_success2 = true;

          setTimeout(() => {
            el.scrollIntoView({ behavior: "smooth" });
          }, 500);
          setTimeout(() => {
            this.alert_success2 = false;
          }, 6000);
        } else {
          this.LoadJsOrder.loadScriptProductStb();
          this.alert_failed2 = true;
          setTimeout(() => {
            this.alert_failed2 = false;
          }, 6000);
        }
      });
  }

  flagging: any = {};

  setflag(id, key, val) {
    console.log(id, key, val);
    if (this.flagging[id] == undefined) {
      this.flagging[id] = {};
      this.flagging[id][key] = val;
    }
    if (this.flagging[id][key] == undefined) {
      this.flagging[id][key] = val;
    }

    this.flagging[id][key] = val;
    console.log(this.flagging[id]);
  }

  flag(id, key) {
    if (this.flagging[id] == undefined) {
      this.flagging[id] = {};
      this.flagging[id][key] = false;
    } else if (this.flagging[id][key] == undefined) {
      this.flagging[id][key] = false;
    }

    //    console.log(this.flagging[id]);
    //    console.log(this.flagging[id][key]);
    return this.flagging[id][key];
  }
}
